import script from "./AggPaymentCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./AggPaymentCapture.vue?vue&type=script&setup=true&lang=js"

import "./AggPaymentCapture.vue?vue&type=style&index=0&id=468c8d89&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468c8d89"]])

export default __exports__